import { User } from '../types/User';
import { toCamelCase } from '../utils/caseConverter';
import { getApiHeaders } from '../utils/apiHeaders';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchUsers = () => {
  return fetch(`${API_BASE_URL}/api/users`, {
      headers: getApiHeaders('none'),
    }).then(res => res.json()).then(data => toCamelCase(data));
};

export async function fetchUserById(id: string): Promise<User> {
  // Try direct endpoint first (if backend supports it)
  try {
    const res = await fetch(`${API_BASE_URL}/api/users/${id}`, {
      headers: getApiHeaders('none'),
    });
    if (res.ok) {
      const data = await res.json();
      return toCamelCase(data);
    }
  } catch {
    // Fallback to fetching all users if direct endpoint doesn't exist
  }
  
  // Fallback: fetch all users and find by ID
  const users: User[] = await fetchUsers();
  const user = users.find(u => String(u.id) === String(id));
  if (!user) throw new Error('User not found');
  return user;
}

export const fetchTeamMembers = (managerId: number): Promise<User[]> => {
  return fetch(`${API_BASE_URL}/api/users/team/${managerId}`, {
    headers: getApiHeaders('none'),
  }).then(res => res.json()).then(data => toCamelCase(data));
};
